import { recordPath, recordRoute } from '@/shared/registry'

import { courseRoute } from '../courses/paths'

/** Where the material vendor pages live. */
export const materialVendorsPath = '/catalog/material-vendors'
export const createMaterialVendorPath = `${materialVendorsPath}/new`
export const materialVendorRoute = recordRoute('catalog', 'material-vendors')
export const editMaterialVendorRoute = `${materialVendorRoute}/edit`

/** The base of Vendor Details' slot names, for other features to add to it. */
export const materialVendorDetailsSlot = 'catalog.material-vendor-details'

/** A vendor's details page. */
export function materialVendorPath(id: string): string {
  return recordPath('catalog', 'material-vendors', id)
}

/** Where the material pages live. */
export const materialsPath = '/catalog/materials'
export const createMaterialPath = `${materialsPath}/new`
export const materialRoute = recordRoute('catalog', 'materials')
export const editMaterialRoute = `${materialRoute}/edit`

/** The base of Material Details' slot names. */
export const materialDetailsSlot = 'catalog.material-details'

/** A material's details page. */
export function materialPath(id: string): string {
  return recordPath('catalog', 'materials', id)
}

/** A course's Materials page: its materials lists. */
export const courseMaterialsRoute = `${courseRoute}/materials`

export function courseMaterialsPath(courseId: string): string {
  return `${recordPath('catalog', 'courses', courseId)}/materials`
}

/** The API's vendor endpoints. */
export const materialVendorsApi = '/catalog/v1/material-vendors'

export function materialVendorApi(id: string): string {
  return `${materialVendorsApi}/${encodeURIComponent(id)}`
}

/** Where a vendor's contact is erased. */
export function materialVendorContactApi(id: string): string {
  return `${materialVendorApi(id)}/contact`
}

/** The API's material endpoints. */
export const materialsApi = '/catalog/v1/materials'

export function materialApi(id: string): string {
  return `${materialsApi}/${encodeURIComponent(id)}`
}

/** A course's materials lists: GET lists them, POST adds one. */
export function courseMaterialsListsApi(courseId: string): string {
  return `/catalog/v1/courses/${encodeURIComponent(courseId)}/materials-lists`
}

/** One materials list. */
export function materialsListApi(id: string): string {
  return `/catalog/v1/materials-lists/${encodeURIComponent(id)}`
}

/** What each materials action needs. */
export const readMaterialsPermission = 'catalog.materials.read'
export const writeMaterialsPermission = 'catalog.materials.write'
export const deleteMaterialsPermission = 'catalog.materials.delete'
export const writeVendorContactPermission = 'catalog.materials.vendor-contact.write'
